import { Head, router, useForm } from "@inertiajs/react"

import AgentForm from "@/components/agents/agent-form"
import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import AdminLayout from "@/layouts/admin-layout"
import { adminAgentsPath, newAdminAgentPath } from "@/routes"
import type {
  Account,
  Agent,
  AvailableModel,
  AvailableSkill,
  BreadcrumbItem,
} from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Agents",
    href: adminAgentsPath(),
  },
  {
    title: "New Agent",
    href: newAdminAgentPath(),
  },
]

export default function NewAgent({
  agent,
  accounts,
  available_skills = [],
  available_models = [],
}: {
  agent: Agent
  accounts: Account[]
  available_skills?: AvailableSkill[]
  available_models?: AvailableModel[]
}) {
  const { data, setData, post, processing, errors } = useForm({
    agent: {
      name: agent.name,
      description: agent.description,
      problem_solved: agent.problem_solved,
      summary: agent.summary,
      state: agent.state,
      account_uid: agent.account_uid ?? "",
      hourly_rate: agent.hourly_rate ?? undefined,
      manual_task_time_in_minutes:
        agent.manual_task_time_in_minutes ?? undefined,
      external_id: agent.external_id ?? undefined,
      slug: "",
      system_prompt: "",
      model_id: "gpt-4.1-nano",
      launch_title: "",
      launch_prompt: "",
      launch_icon: "",
      agent_metrics_attributes: [],
      skills: agent.skills ?? [],
      integration_kinds: [],
      resources_by_kind: {},
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(adminAgentsPath(), {
      forceFormData: true,
    })
  }

  function handleCancel() {
    router.visit(adminAgentsPath())
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title="New Agent" />
        </div>
        <RecordForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <AgentForm
            data={data}
            setData={setData}
            errors={errors}
            accounts={accounts}
            availableSkills={available_skills}
            availableModels={available_models}
            mode="new"
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
